import { getTelLinkFromPhone } from "./getTelLinkFromPhone";
import { getWhatsappLinkFromPhone } from "./getWhatsappLinkFromPhone";

export function getContact(component) {
  const { tel, whatsapp, email, local_text, local_link, opening_hours } =
    component;
  const contact = {};

  if (tel) {
    let telSplit = tel.split(";");

    if (Array.isArray(telSplit) && telSplit.length > 1) {
      let telArray = [];
      telSplit.forEach(function (val) {
        telArray.push({
          name: "Telefone",
          text: val,
          link: getTelLinkFromPhone(val),
          target: "_self",
          icon: "fa-phone-alt",
          size: 20,
        });
      });

      contact.tel = telArray;
    } else {
      contact.tel = {
        name: "Telefone",
        text: tel,
        link: getTelLinkFromPhone(tel),
        target: "_self",
        icon: "fa-phone-alt",
        size: 20,
      };
    }
  }

  if (whatsapp) {
    let whatsappSplit = whatsapp.split(";");

    if (Array.isArray(whatsappSplit) && whatsappSplit.length > 1) {
      let whatsappArray = [];
      whatsappSplit.forEach(function (val) {
        whatsappArray.push({
          name: "WhatsApp",
          text: val,
          link: getWhatsappLinkFromPhone(val),
          target: "_blank",
          icon: "fa-whatsapp",
          size: 20,
        });
      });

      contact.whatsapp = whatsappArray;
    } else {
      contact.whatsapp = {
        name: "WhatsApp",
        text: whatsapp,
        link: getWhatsappLinkFromPhone(whatsapp),
        target: "_blank",
        icon: "fa-whatsapp",
        size: 20,
      };
    }
  }

  if (local_link) {
    contact.local = {
      name: "Endereço",
      text: local_text,
      link: local_link,
      target: "_blank",
      icon: "fa-map-marker-alt",
      size: 20,
    };
  }

  if (email) {
    contact.email = {
      name: "E-mail",
      text: email,
      link: "mailto:" + email,
      target: "_self",
      icon: "fa-envelope",
      size: 20,
    };
  }

  if (opening_hours) {
    contact.opening_hours = {
      name: "Atendimento",
      text: opening_hours,
      icon: "fa-clock",
      size: 20,
    };
  }

  return contact;
}
